var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { withTheme } from 'styled-components';
import { ArrowLeft, ArrowRight } from '@volkswagen-onehub/icons-core';
import { CTA, } from '../call-to-action';
const Arrow = withTheme((props) => props.theme.direction === 'rtl' ? (React.createElement(ArrowLeft, { variant: props.size === 'small' ? 'small' : 'default', "aria-hidden": true })) : (React.createElement(ArrowRight, { variant: props.size === 'small' ? 'small' : 'default', "aria-hidden": true })));
export const ButtonNext = (props) => {
    const { children, size } = props, rest = __rest(props, ["children", "size"]);
    return (React.createElement(CTA, Object.assign({}, rest, { icon: React.createElement(Arrow, { size: size }), iconPosition: "end", size: size }), children));
};
